import { gql } from '@apollo/client';

const UPDATE_ASSIGNMENT = gql`
  mutation updateAssignment($data: AssignmentUpdateInput!) {
    updateAssignment(data: $data) {
      id
      groups {
        id
        name
      }
      students {
        firstName
        lastName
        id
      }
    }
  }
`;

export default UPDATE_ASSIGNMENT;
